<h6 class="fw-bold">
  <span class="me-2 order">{{ order }}</span>
  <span class="underline">{{ underlineString }}</span>
  <span>{{ normalString }}</span>
</h6>
